export const API_BASE = import.meta.env.VITE_API_URL || 'https://vendas-dashboard-backend.allef-d1a.workers.dev'
